import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFilter } from '../../hooks'
import { sendStaffAppMetaData } from '../../eventTriggers'

export const Contacts = () => {
  const { contacts, config } = useSelector(state=>state)
  const [ filter, setFilter, Input ] = useFilter()
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "contact",
        resource
      }
    })
    sendStaffAppMetaData(config.tab_default_meta_data.find(tab=>tab.detail == 'contacts').modal)
  }

  return(
    <>
      <Input {...{ filter, setFilter }}/>
      {
        contacts.filter(contact=>((contact.name || '').toLowerCase().includes(filter.toLowerCase()))).map(contact=>(
          <div key={contact.id} onClick={()=>handleClick(contact)} className="p-4 border-bottom clickable">
            <div className="d-flex justify-content-between align-items-center">
              <b>{ contact.name }</b>
              <div>
                {
                  contact.consent ?
                  <div className="badge badge-success">CONSENT</div> :
                  <div className="badge badge-danger">NO CONSENT</div>
                }
              </div>
            </div>
            <div className="text-secondary pt-1">{ contact.phone || contact.email || contact.kind }</div>
          </div>
        ))
      }
    </>
  )
}